import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { Filter } from '../../models/filter-models';
import { BaseTypeTier, DisplayType, GearSizeType, Rarity, SocketedItemType, VendoringGearType } from "../../models/enums";
import { FilterService } from '../../services/filter.service';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { ItemDataService } from '../../services/item-data.service';
import { BaseComponent } from '../../common/base.component';
import { ActiveRules } from '../../services/filter-generator.service';
import { SelectGearSizeComponent } from '../../common/select/select-gear-size/select-gear-size.component';
import { EquipmentType } from '../../models/equipment-type.enum';
import { VendoringGearComponent } from '../common/vendoring-gear/vendoring-gear.component';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';

@Component({
  selector: 'app-vendor-recipe-filters-poe1',
  imports: [FormsModule, FilterTitleComponent, AutocompleteComponent, SelectGearSizeComponent, VendoringGearComponent,
    EquipmentTierPickerComponent],
  templateUrl: './vendor-recipe-filters-poe1.component.html',
  styleUrl: './vendor-recipe-filters-poe1.component.scss'
})
export class VendorRecipeFiltersPoe1Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  SocketedItemType = SocketedItemType;
  BaseTypeTier = BaseTypeTier;
  GearSizeType = GearSizeType;
  VendoringGearType = VendoringGearType;
  DisplayType = DisplayType;
  Rarity = Rarity;
  EquipmentType = EquipmentType;

  recipeTarget = [
    { name: 'Helmets' },
    { name: 'Gloves' },
    { name: 'Boots' },
    { name: 'Body Armours' },
    { name: 'Weapons' },
    { name: 'Jewellery' }
  ];

  influences: { name: string, image: string }[] = [];

  showVendoringMagicsFilters = false;

  constructor(private filterService: FilterService, private itemDataService: ItemDataService) {
    super();
    this.influences = this.itemDataService.getInfluences();
  }

  toggleShowChaosRecipe = () => { this.filter.showChaosRecipe = !this.filter.showChaosRecipe; this.updateFilter(); }
  chaosRecipeTargetChanged(newValues: string[]) {
    this.filter.showChaosRecipeTarget = newValues;
    this.updateFilter();
  }

  toggleShowExaltRecipe = () => { this.filter.showExaltRecipe = !this.filter.showExaltRecipe; this.updateFilter(); }
  exaltRecipeTargetChanged(newValues: string[]) {
    this.filter.showExaltRecipeTarget = newValues;
    this.updateFilter();
  }
  exaltRecipeInfluenceChanged(newValues: string[]) {
    this.filter.showExaltRecipeInfluence = newValues;
    this.updateFilter();
  }

  toggleShowVendoringMagics = () => { this.filter.showVendoringMagics = !this.filter.showVendoringMagics; this.updateFilter(); }
  toggleShowJewellersRecipe = () => { this.filter.showJewellersRecipe = !this.filter.showJewellersRecipe; this.updateFilter(); }
  toggleShowChromaticRecipe = () => { this.filter.showChromaticRecipe = !this.filter.showChromaticRecipe; this.updateFilter(); }
  toggleShowTieredRareGear = () => { this.filter.showTieredRareGear = !this.filter.showTieredRareGear; this.updateFilter(); }
  toggleShowTieredMagicGear = () => { this.filter.showTieredMagicGear = !this.filter.showTieredMagicGear; this.updateFilter(); }
  toggleShowQualityWeapons = () => { this.filter.showQualityWeapons = !this.filter.showQualityWeapons; this.updateFilter(); }
  toggleShowQualityArmour = () => { this.filter.showQualityArmour = !this.filter.showQualityArmour; this.updateFilter(); }
  toggleShowQualityFlasks = () => { this.filter.showQualityFlasks = !this.filter.showQualityFlasks; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}

